import { CompanyNotChangedFields } from '../constants/companies';

class FormHelper {
  static resetFormsFieldErrors = (form, onlyResetFields) => (changedFields) => {
    if (changedFields[0]) {
      const field = changedFields[0];
      const name = field.name[0];

      if (field.errors?.length > 0) {
        return;
      }

      if (!onlyResetFields) {
        form.setFields([
          {
            name,
            errors: [],
          },
        ]);
      } else {
        if (onlyResetFields.includes(name)) {
          form.setFields([
            {
              name,
              errors: [],
            },
          ]);
        }
      }
    }
  };

  static normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  static beforeUpload = () => false;

  static isCompanyFieldDisabled = (fieldName, isEdit = false) => {
    // return isEdit && !!CompanyNotChangedFields.find(i => i === fieldName);
    //for now, we don't want to disable any fields, let's check if we need to disable them later
    return false;
  };
}

export default FormHelper;
